module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4jWMYOuB/no3A/zybAGIdzIIhAjWEgYFhP5S7AUMBFsBEwBBHTC3YASM+QxgnHfmAVRcWwEgNQxhgBlFqCNggJEMMGBgYJjAwMHzEUIUfLGCcdOQBRmCTC6jnNRiDKoFNDcMY0QXINQwjsKEaYSkaZiDpBqEZ1kisQYMMMDAwAADu3zn4ThDMGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@1x/ic_btn_arrow_left.png
// module id = 718
// module chunks = 0